module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "closing-date"
  }, [_c('h2', [_vm._v("Closing date widget")]), _vm._v(" "), _c('p', [_vm._v("Closing date: "), _c('span', {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.msg))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1cc8b018!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClosingDate.vue
// module id = 307
// module chunks = 2